/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Suspense } from 'react'

import PageSpinner from 'components/commons/spinner'

const CollectionListHeader = React.lazy(() => import('./collection-list-header'))
const CollectionListItem = React.lazy(() => import('./collection-list-item'))

const CollectionList = ({ isRequesting, hasDataToLoad, onLoadMore, ...props }: any) => {
  return (
    <Suspense fallback={<PageSpinner />}>
      <div className='w-full overflow-x-auto py-4 md:bg-white lg:bg-white'>
        <table className='w-full flex flex-row flex-nowrap overflow-hidden mb-4'>
          <CollectionListHeader />
          <CollectionListItem {...props} />
        </table>

        {!isRequesting && hasDataToLoad && (
          <div className='flex justify-center py-6 rounded-lg bg-white md:bg-transparent lg:bg-transparent'>
            <button className='text-blue-700 underline underline-offset-2' onClick={onLoadMore}>
              Load More Invalid Slugs
            </button>
          </div>
        )}

        {isRequesting && hasDataToLoad && (
          <div className='flex justify-center py-6'>
            <PageSpinner />
          </div>
        )}
      </div>
    </Suspense>
  )
}

export default CollectionList
